/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Grid, MenuItem, Select } from '@material-ui/core';

function GiftsValuesDropDown({ ...props }) {
  const [repeat, setRepeat] = useState(1);
  const onChangeRepeat = (event) => {
    setRepeat(event.target.value);
    props.handleRepeat(event.target.value);
    // return repeat;
  };

  return (
    <Grid container alignItems='right' justifyContent='flex-end'>
      <Grid item container lg={12} alignContent='right' justifyContent='center'>
        <div className='coinsGiveOption'>
          <Select
            labelId='repeat'
            id='repeat'
            value={repeat}
            onChange={(e) => { onChangeRepeat(e); }}
            style={{ color: 'white' }}
          >
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={99}>99</MenuItem>
            <MenuItem value={499}>499</MenuItem>
            <MenuItem value={999}>999</MenuItem>
          </Select>
        </div>

        <div className='coinsGiveBtn' id='sendGift' onClick={props.sendVg}>
          Give
        </div>
      </Grid>
    </Grid>
  );
}

export default GiftsValuesDropDown;
